var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    fill: "#FF8989",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.936 54H50.0627C49.875 53.9992 49.6956 54.0777 49.5687 54.216C49.4418 54.3543 49.3791 54.5397 49.396 54.7267L51.112 73.5747C51.2369 74.9484 52.3887 76.0001 53.768 76H66.2307C67.61 76.0001 68.7619 74.9484 68.8867 73.5747L70.6 54.7267C70.6167 54.5403 70.5543 54.3555 70.428 54.2173C70.3018 54.079 70.1233 54.0001 69.936 54ZM57.6694 71.3333C57.6694 71.8856 57.2216 72.3333 56.6694 72.3333C56.1171 72.3333 55.6694 71.8856 55.6694 71.3333V59.3333C55.6694 58.7811 56.1171 58.3333 56.6694 58.3333C57.2216 58.3333 57.6694 58.7811 57.6694 59.3333V71.3333ZM63.336 72.3333C63.8883 72.3333 64.336 71.8856 64.336 71.3333V59.3333C64.336 58.7811 63.8883 58.3333 63.336 58.3333C62.7837 58.3333 62.336 58.7811 62.336 59.3333V71.3333C62.336 71.8856 62.7837 72.3333 63.336 72.3333Z",
    fill: "#FF0F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 49.3333H73.3334C74.0698 49.3333 74.6667 49.9303 74.6667 50.6667C74.6667 51.403 74.0698 52 73.3334 52H46.6667C45.9303 52 45.3334 51.403 45.3334 50.6667C45.3334 49.9303 45.9303 49.3333 46.6667 49.3333H53C53.0884 49.3333 53.1732 49.2982 53.2357 49.2357C53.2983 49.1732 53.3334 49.0884 53.3334 49V47.3333C53.3334 45.4924 54.8258 44 56.6667 44H63.3334C65.1743 44 66.6667 45.4924 66.6667 47.3333V49C66.6667 49.1841 66.8159 49.3333 67 49.3333ZM56 47.3333V49C56 49.1841 56.1493 49.3333 56.3334 49.3333H63.6667C63.8508 49.3333 64 49.1841 64 49V47.3333C64 46.9651 63.7016 46.6667 63.3334 46.6667H56.6667C56.2985 46.6667 56 46.9651 56 47.3333Z",
    fill: "#FF0F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.77a37b305962c6be224cdbf7f482754c.svg";
export { ForwardRef as ReactComponent };